export default __webpack_public_path__ + "a28ca6f25220cdac4d07e53bfe5ff5e3.png";